import * as actions from './actions';

export default {
  player_bet: actions.getPlayersBets,
};